
    export default {
      name: "TextualBlockCityB",
      props: {
        info_lading: {
          type: Object,
          default: {
            lading_page: [],
            reviews: [],
            price: []
          }
        },
        title: {
          type: String,
          default: '',
        },
        city_a: {
          type: String,
          default: '',
        },
        city_b: {
          type: String,
          default: '',
        }
      },
    }
